export function parseProdRecExtra(value) {
  if (value == null || value === '') return []
  if (Array.isArray(value)) {
    return value.map((id) => Number(id)).filter((id) => Number.isFinite(id) && id > 0)
  }
  try {
    const parsed = JSON.parse(String(value))
    if (!Array.isArray(parsed)) return []
    return parsed.map((id) => Number(id)).filter((id) => Number.isFinite(id) && id > 0)
  } catch (e) {
    return []
  }
}

export function prodRecIds(row) {
  if (!row) return []
  const primary = row.rec_id != null && row.rec_id !== '' ? Number(row.rec_id) : null
  const extra = parseProdRecExtra(row.prod_recExtra).filter((id) => id !== primary)
  if (primary && Number.isFinite(primary) && primary > 0) return [primary, ...extra]
  return extra
}

export function splitProdRecIds(ids, previousPrimary) {
  const clean = []
  ;(ids || []).forEach((id) => {
    const n = Number(id)
    if (!Number.isFinite(n) || n <= 0) return
    if (!clean.includes(n)) clean.push(n)
  })
  const prev = previousPrimary != null && previousPrimary !== '' ? Number(previousPrimary) : null
  const ordered = prev && clean.includes(prev)
    ? [prev, ...clean.filter((id) => id !== prev)]
    : clean
  return {
    rec_id: ordered[0] || null,
    prod_recExtra: ordered.length > 1 ? JSON.stringify(ordered.slice(1)) : null,
  }
}

export function productLinkedToRec(row, recId) {
  const rid = Number(recId)
  if (!rid) return false
  return prodRecIds(row).includes(rid)
}
